export const EVENT_TYPE = [
    'ORSEC',
    'EVASAN',
    'RECHERCHE',
    'EXERCICE',
    'AUTRE',
];

export const EVENT_ORIGIN = [
    'CODIS',
    'SAMU',
    'CORG',
    'USEM',
    'ARCC',
    'DIRECT',
    'AUTRE',
];

export const EVENT_SUITE = [
    'Régulation - Enquête',
    'Aucun moyen engagé',
    'Intervention confiée SDIS',
    'Intervention confiée Pisteurs',
    'Intervention confiée FSI',
];

export const STATUS = {
    'DEPART': 'orange',
    'ASL': 'orange',
    'EVAC': 'purple',
    'CH': 'purple',
    'DEPOSE': 'purple',
    'RETOUR': 'green',
    'FIN': 'green'
};

export const COLOR = STATUS;

export const AUTORITES = {
    'CDU': 'CR Commandant Unité',
    'CCie': 'CR Commandant Cie',
    'OP Ggd': 'CR OP Ggd',
    'PARQUET': 'CR Parquet',
    'PREFECTURE': 'CR Préfecture',
    'MAIRIE': 'CR Mairie'
};

export const INFORMATIONS = {
    'CODIS': 'Information CODIS',
    'SMUR/SAMU': 'Information SMUR-SAMU',
    'CORG': 'Information CORG'
};

export const HORAIRES = {
    'DEBUT CONF': 'Début de conférence',
    'FIN CONF': 'Fin de conférence',
    'DEBUT R.MED': 'Conférence régulation médicale',
    'FIN R.MED': 'Fin de régulation médicale',
};

export const EVENT_PRECISION = [
    'GENDLOC',
    'AML',
    'REQUERANT',
    'SECOURISTE',
    'APPROX'
];

export const SW_MESSAGE_TYPE = {
    EVENT_UPDATE: 'EVENT_UPDATE',
    MESSAGE_UPDATE: 'MESSAGE_UPDATE',
    EVENT_DETAILS_UPDATE: 'EVENT_DETAILS_UPDATE',
    HELICOPTER_UPDATE: 'HELICOPTER_UPDATE',
    WS_CONNECT: 'WS_CONNECT',
    WS_DISCONNECT: 'WS_DISCONNECT',
};

export const MINUTE_IN_MS = 60000;
export const SAR_ZONE_TYPE_ID = 16;